module.exports = function (Utils, Konva) {
    'use strict';
    function WaveformShape(options) {
        this._color = options.color;
        var shapeOptions = {};
        if (Utils.isString(options.color)) {
            shapeOptions.fill = options.color;
        } else if (Utils.isLinearGradientColor(options.color)) {
            var startY = options.view._height * (options.color.linearGradientStart / 100);
            var endY = options.view._height * (options.color.linearGradientEnd / 100);
            shapeOptions.fillLinearGradientStartPointY = startY;
            shapeOptions.fillLinearGradientEndPointY = endY;
            shapeOptions.fillLinearGradientColorStops = [
                0,
                options.color.linearGradientColorStops[0],
                1,
                options.color.linearGradientColorStops[1]
            ];
        } else {
            throw new TypeError('Unknown type for color property');
        }
        Konva.Shape.call(this, shapeOptions);
        this._view = options.view;
        this._segment = options.segment;
        this.sceneFunc(this._sceneFunc);
        this.hitFunc(this._waveformShapeHitFunc);
    }
    WaveformShape.prototype = Object.create(Konva.Shape.prototype);
    WaveformShape.prototype.setWaveformColor = function (color) {
        if (Utils.isString(color)) {
            this.fill(color);
            this.fillLinearGradientStartPointY(null);
            this.fillLinearGradientEndPointY(null);
            this.fillLinearGradientColorStops(null);
        } else if (Utils.isLinearGradientColor(color)) {
            this.fill(null);
            var startY = this._view._height * (color.linearGradientStart / 100);
            var endY = this._view._height * (color.linearGradientEnd / 100);
            this.fillLinearGradientStartPointY(startY);
            this.fillLinearGradientEndPointY(endY);
            this.fillLinearGradientColorStops([
                0,
                color.linearGradientColorStops[0],
                1,
                color.linearGradientColorStops[1]
            ]);
        } else {
            throw new TypeError('Unknown type for color property');
        }
    };
    WaveformShape.prototype.fitToView = function () {
        this.setWaveformColor(this._color);
    };
    WaveformShape.prototype._sceneFunc = function (context) {
        var frameOffset = this._view.getFrameOffset();
        var width = this._view.getWidth();
        var height = this._view.getHeight();
        this._drawWaveform(context, this._view.getWaveformData(), frameOffset, this._segment ? this._view.timeToPixels(this._segment.startTime) : frameOffset, this._segment ? this._view.timeToPixels(this._segment.endTime) : frameOffset + width, width, height);
    };
    WaveformShape.prototype._drawWaveform = function (context, waveformData, frameOffset, startPixels, endPixels, width, height) {
        if (startPixels < frameOffset) {
            startPixels = frameOffset;
        }
        var limit = frameOffset + width;
        if (endPixels > limit) {
            endPixels = limit;
        }
        if (endPixels > waveformData.length) {
            endPixels = waveformData.length;
        }
        var channels = waveformData.channels;
        var waveformTop = 0;
        var waveformHeight = Math.floor(height / channels);
        for (var i = 0; i < channels; i++) {
            if (i === channels - 1) {
                waveformHeight = height - (channels - 1) * waveformHeight;
            }
            this._drawChannel(context, waveformData.channel(i), frameOffset, startPixels, endPixels, waveformTop, waveformHeight);
            waveformTop += waveformHeight;
        }
    };
    WaveformShape.prototype._drawChannel = function (context, channel, frameOffset, startPixels, endPixels, top, height) {
        var x, amplitude;
        var amplitudeScale = this._view.getAmplitudeScale();
        var lineX, lineY;
        context.beginPath();
        for (x = startPixels; x < endPixels; x++) {
            amplitude = channel.min_sample(x);
            lineX = x - frameOffset + 0.5;
            lineY = top + WaveformShape.scaleY(amplitude, height, amplitudeScale) + 0.5;
            context.lineTo(lineX, lineY);
        }
        for (x = endPixels - 1; x >= startPixels; x--) {
            amplitude = channel.max_sample(x);
            lineX = x - frameOffset + 0.5;
            lineY = top + WaveformShape.scaleY(amplitude, height, amplitudeScale) + 0.5;
            context.lineTo(lineX, lineY);
        }
        context.closePath();
        context.fillShape(this);
    };
    WaveformShape.prototype._waveformShapeHitFunc = function (context) {
        if (!this._segment) {
            return;
        }
        var frameOffset = this._view.getFrameOffset();
        var viewWidth = this._view.getWidth();
        var viewHeight = this._view.getHeight();
        var startPixels = this._view.timeToPixels(this._segment.startTime);
        var endPixels = this._view.timeToPixels(this._segment.endTime);
        var offsetY = 10;
        var hitRectHeight = viewHeight - 2 * offsetY;
        if (hitRectHeight < 0) {
            hitRectHeight = 0;
        }
        var hitRectLeft = startPixels - frameOffset;
        var hitRectWidth = endPixels - startPixels;
        if (hitRectLeft < 0) {
            hitRectWidth -= -hitRectLeft;
            hitRectLeft = 0;
        }
        if (hitRectLeft + hitRectWidth > viewWidth) {
            hitRectWidth -= hitRectLeft + hitRectWidth - viewWidth;
        }
        context.beginPath();
        context.rect(hitRectLeft, offsetY, hitRectWidth, hitRectHeight);
        context.closePath();
        context.fillStrokeShape(this);
    };
    WaveformShape.scaleY = function (amplitude, height, scale) {
        var y = -(height - 1) * (amplitude * scale + 128) / 255 + (height - 1);
        return Utils.clamp(Math.floor(y), 0, height - 1);
    };
    return WaveformShape;
}(require('./utils'), require('konva'));